module.exports = __webpack_public_path__ + "media/images/country_flags/gu-7afaece66fb165758a42e76d116660ef.png";